import * as React from 'react';
import { ILinks7Data } from '../absolute-ff.props.autogenerated';

export interface IContentCardLinks7 {
    links7: ILinks7Data[];
}

const ContentCardLinks7: React.FC<IContentCardLinks7> = ({ links7 }) => (
    <div className='ms-content-block__cta'>
        {links7.map((cta: ILinks7Data, index: number) => {
            const btnClass = index === 0 ? 'msc-cta__primary' : 'msc-cta__secondary';
            return <a
                key={`link-${index}`}
                className={btnClass}
                role='button'
                title={cta.linkText}
                href={cta.linkUrl && cta.linkUrl.destinationUrl}
                aria-label={cta.ariaLabel}
                target={cta.openInNewTab ? '_blank' : undefined}
            >
                {cta.linkText}
            </a>;
        })}
    </div>
);

export default ContentCardLinks7;